import { MdOutlineTrendingUp } from "react-icons/md";
import { FiBriefcase, FiArrowDownRight, FiArrowUpRight } from "react-icons/fi";
import { RiUser3Line } from "react-icons/ri";
import { TiTick } from "react-icons/ti";
import {
  FaChevronDown,
  FaRegEdit,
  FaSave,
  FaChevronRight,
  FaRegIdCard,
  FaUserAlt,
} from "react-icons/fa";
import {
  AiFillDelete,
  AiOutlineFieldTime,
  AiTwotoneTrophy,
  AiOutlineLogout,
  AiFillCamera,
  AiFillCreditCard,
  AiFillGift,
  AiFillQuestionCircle,
  AiOutlineSetting,
} from "react-icons/ai";
import {
  IoMdSend,
  IoIosNotifications,
  IoMdArrowDropup,
  IoMdArrowDropdown,
  IoIosArrowRoundForward,
} from "react-icons/io";
import {
  BsImage,
  BsCheckCircle,
  BsDatabaseFillCheck,
  BsShieldFillCheck,
  BsDash,
} from "react-icons/bs";
import { ImUsers } from "react-icons/im";
import { SiAdblock } from "react-icons/si";
import { RxCross2, RxAvatar } from "react-icons/rx";
import { GrStatusGoodSmall } from "react-icons/gr";
import {
  FcProcess,
  FcAddDatabase,
  FcDeleteDatabase,
  FcPhoneAndroid,
  FcLock,
  FcCustomerSupport,
} from "react-icons/fc";
import {
  MdCancel,
  MdCurrencyExchange,
  MdAccountBalanceWallet,
  MdOutlineFileDownload,
  MdOutlineFileUpload,
  MdHistory,
  MdOutlineMailOutline,
} from "react-icons/md";
import { IoIosAddCircle } from "react-icons/io";
import {
  BiTimeFive,
  BiHomeAlt,
  BiDetail,
  BiSolidBank,
  BiMoneyWithdraw,
  BiSolidCheckShield,
  BiBadgeCheck,
} from "react-icons/bi";
import { TbEqual, TbMoneybag } from "react-icons/tb";
import {
  HiOutlinePlusSm,
  HiOutlineRefresh,
  HiOutlineUser,
} from "react-icons/hi";
import { GiReceiveMoney } from "react-icons/gi";
import { IoChevronBackSharp } from "react-icons/io5";
import { RiShieldKeyholeLine } from "react-icons/ri";
import { GrLanguage } from "react-icons/gr";
import { IoWallet, IoArrowBackOutline, IoCheckmark } from "react-icons/io5";
import { LuSettings2 } from "react-icons/lu";
import { PiTextTFill, PiCopySimple, PiHandWithdraw } from "react-icons/pi";
import { FcVip } from "react-icons/fc";

const TrendIcon = MdOutlineTrendingUp;
const ProfileIcon = RiUser3Line;
const BriefcaseIcon = FiBriefcase;
const TickIcon = TiTick;
const ChevronRightIcon = FaChevronRight;
const UsersIcon = ImUsers;
const DurationIcon = AiOutlineFieldTime;
const TimeIcon = BiTimeFive;
const EqualIcon = TbEqual;
const PlusIcon = HiOutlinePlusSm;
const LevelIcon = AiTwotoneTrophy;
const LogoutIcon = AiOutlineLogout;
const CameraIcon = AiFillCamera;
const DatabaseIcon = FcAddDatabase;
const DeleteDatabaseIcon = FcDeleteDatabase;
const CardIcon = FaRegIdCard;
const MoneyIcon = GiReceiveMoney;
const ChevronBackIcon = IoChevronBackSharp;
const ChevronIcon = FaChevronDown;
const TrashIcon = AiFillDelete;
const SendIcon = IoMdSend;
const EditIcon = FaRegEdit;
const ImageIcon = BsImage;
const UnBlockIcon = SiAdblock;
const CrossIcon = RxCross2;
const CheckCircleIcon = BsCheckCircle;
const StatusIcon = GrStatusGoodSmall;
const ProcessIcon = FcProcess;
const CancelIcon = MdCancel;
const SaveIcon = FaSave;
const AddCircleIcon = IoIosAddCircle;
const AndroidPhoneIcon = FcPhoneAndroid;
const LockIcon = FcLock;
const UserIcon = FaUserAlt;
const HomeIcon = BiHomeAlt;
const CreditCardIcon = AiFillCreditCard;
const GiftIcon = AiFillGift;
const ExchangeIcon = MdCurrencyExchange;
const DetailIcon = BiDetail;
const CustomerSupportIcon = FcCustomerSupport;
const BankIcon = BiSolidBank;
const WithdrawIcon = BiMoneyWithdraw;
const QuestionIcon = AiFillQuestionCircle;
const DatabseCheckIcon = BsDatabaseFillCheck;
const NotificationIcon = IoIosNotifications;
const SecurityIcon = BsShieldFillCheck;
const SettingIcon = AiOutlineSetting;
const ShieldIcon = BiSolidCheckShield;
const DashIcon = BsDash;
const PasswordIcon = RiShieldKeyholeLine;
const AccountIcon = MdAccountBalanceWallet;
const RefreshIcon = HiOutlineRefresh;
const MoneyBagIcon = TbMoneybag;
const GlobeIcon = GrLanguage;
const DownloadIcon = MdOutlineFileDownload;
const UploadIcon = MdOutlineFileUpload;
const HistoryIcon = MdHistory;
const MailIcon = MdOutlineMailOutline;
const VerifyIcon = BiBadgeCheck;
const PersonalIcon = HiOutlineUser;
const BalanceHistoryIcon = IoWallet;
const Setting2Icon = LuSettings2;
const TranslateIcon = PiTextTFill;
const AvatarIcon = RxAvatar;
const CopyIcon = PiCopySimple;
const BackIcon = IoArrowBackOutline;
const CheckIcon = IoCheckmark;
const DownIcon = FiArrowDownRight;
const UpIcon = FiArrowUpRight;
const ArrowUpIcon = IoMdArrowDropup;
const ArrowDownIcon = IoMdArrowDropdown;
const WithdrawMoneyIcon = PiHandWithdraw;
const PriceArrowIcon = IoIosArrowRoundForward;
const VIPIcon = FcVip;

export {
  TrendIcon,
  ProfileIcon,
  BriefcaseIcon,
  TickIcon,
  ChevronRightIcon,
  UsersIcon,
  DurationIcon,
  TimeIcon,
  EqualIcon,
  PlusIcon,
  LevelIcon,
  LogoutIcon,
  CameraIcon,
  DatabaseIcon,
  DeleteDatabaseIcon,
  CardIcon,
  MoneyIcon,
  ChevronBackIcon,
  ChevronIcon,
  TrashIcon,
  SendIcon,
  EditIcon,
  ImageIcon,
  UnBlockIcon,
  CrossIcon,
  CheckCircleIcon,
  StatusIcon,
  ProcessIcon,
  CancelIcon,
  AddCircleIcon,
  SaveIcon,
  AndroidPhoneIcon,
  LockIcon,
  UserIcon,
  HomeIcon,
  CreditCardIcon,
  GiftIcon,
  ExchangeIcon,
  DetailIcon,
  CustomerSupportIcon,
  BankIcon,
  WithdrawIcon,
  QuestionIcon,
  DatabseCheckIcon,
  NotificationIcon,
  SecurityIcon,
  SettingIcon,
  ShieldIcon,
  DashIcon,
  PasswordIcon,
  AccountIcon,
  RefreshIcon,
  MoneyBagIcon,
  GlobeIcon,
  DownloadIcon,
  UploadIcon,
  HistoryIcon,
  MailIcon,
  VerifyIcon,
  PersonalIcon,
  BalanceHistoryIcon,
  Setting2Icon,
  TranslateIcon,
  AvatarIcon,
  CopyIcon,
  BackIcon,
  CheckIcon,
  UpIcon,
  DownIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  WithdrawMoneyIcon,
  PriceArrowIcon,
  VIPIcon,
};
